import withBookingCurrency from 'components/queries/withBookingCurrencyQuery';
import RefundsContainer from './RefundsContainer';

export default withBookingCurrency(RefundsContainer);
